module.exports = __webpack_public_path__ + "img/Color services.svg";